export const INVALID_PASSWORD = 'currentPassword: PASSWORD_INCORRECT';
